/* eslint-disable global-require */
import React from 'react';
import { OPTIONS } from '../marker.options';
import { Marker, InfoWindow } from '@react-google-maps/api';
import markerSupport from '../../../Assets/icons/marker_support.svg';
import markerPay from '../../../Assets/icons/marker_pay.svg';
import markerPaySelected from '../../../Assets/icons/marker_pay_selected.svg';
import markerBrilla from '../../../Assets/icons/marker_brilla.svg';
import markerRechargeSelected from '../../../Assets/icons/marker_recharge_selected.svg';
import markerRecharge from '../../../Assets/icons/marker_recharge.svg';

const getIconImage = (type, selected) => {
  switch (type) {
    case OPTIONS.support:
      return markerSupport;
    case OPTIONS.pay:
      if (selected) {
        return markerPaySelected;
      }

      return markerPay;
    case OPTIONS.coupon:
      return markerBrilla;
    case OPTIONS.recharge:
      if (selected) {
        return markerRechargeSelected;
      }

      return markerRecharge;
    default:
      return '';
  }
};

const getIcon = (type, selected) => {
  return {
    url: getIconImage(type, selected),
    scaledSize: { width: 40, height: 40 }
  };
};

const MarkerWrapper = props => {
  const icon = getIcon(props.type, props.showInfoWindow);
  const toggleInfoWindow = () => {
    if (props.index === props.selectedMarker) {
      props.selectInfoWindow(null);
    } else {
      props.selectInfoWindow(props.index);
    }
  };
  return (
    <Marker onClick={toggleInfoWindow} {...props} icon={icon}>
      {props.showInfoWindow && (
        <InfoWindow onCloseClick={toggleInfoWindow}>
          {props.iwcomponent}
        </InfoWindow>
      )}
    </Marker>
  );
};

export default MarkerWrapper;
